module.exports = __webpack_public_path__ + "img/mC-big-V2.14f419fb.png";